'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetUserMe } = useUserService();
  const { data: user, isLoading, isFetching } = useGetUserMe();
  const isAuthenticated = Boolean(user);

  return { isAuthenticated, user, isLoading, isFetching };
};
